<div class="devices-layout"> 
  <div class="devices-search-filter">
    <sync-search class="data-search" [size]="'default'" [placeholder]="'Search device names'"
      [label]="'Search device names'" [isCancellable]="true" [showTrailAdornment]="false" [isRounded]="true"
      [onSearch]="onSearch" [inputChange]="onSearch">
    </sync-search>
    <sync-switch [size]="'default'" [label]="'Show removed devices'" [labelPosition]="'before'"
      [onChange]="onToggleShowHideDevice">
    </sync-switch>
  </div>
      <div class="devices-list">
        <sync-data-list *ngIf="devicesColumns.length" class="responsive-list" [data]="devicesInChunk" [columns]="devicesColumns" [showBulkActions]="true"
          [bulkActions]="[{name: 'name', icon: 'icon', onClick: onActionClick}]"
          [showPagination]="devicesPaginationConfig.length >= 10" [paginationConfig]="devicesPaginationConfig"
          [sortedColumnKey]="sortedColumnKey" [isSortAsc]="isSortAsc" [listViewBreakpoint]="'905px'" [isLoading]="isLoading"
          [countText]="countText" [isSelectable]="false">
        </sync-data-list>
      </div>
      <div class="no-searchResult" *ngIf="devicesInChunk.length === 0 && !isLoading">
        <sync-icon [name]="'search'"></sync-icon>
        <span class="h4">No results found.</span>
        <span class="body-2">Change your search criteria and try again.</span>
      </div>
      <div class="dialogBody">
        <sync-dialog [config]="{
          title: dialog['title'],
          isClosable: false,
          actionButton: dialog['action'],
          cancelButton: 'Cancel',
          onActionClick: onActionClick,
          onCancelClick: onCancelClick,
          isButtonLoading: isActionLoading,
        }" [open]="isDialogOpen" [onClose]="onCancelClick"
          [isCritical]="(dialog.type === 'delete' || dialog.type === 'sign-out') ? true : false">
          <ng-container [ngSwitch]="dialog.type">
            <!-- Rename Start -->
            <div class="nameContainer" *ngSwitchCase="'rename'">
              <sync-alert *ngIf="deviceInputError" [type]="'critical'" [leadIcon]="'info'" [showLeadIcon]="true"
                [title]="'Correct the errors in the form below, then try again.'" [showCloseButton]="false"
                [showActions]="false" [description]="''" [showPrimaryAction]="false" 
                [showSecondaryAction]="false"></sync-alert>
              <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
              <sync-text-field [label]="'Device name'" [placeholder]="'Device name'" [inputType]='"text"'
                [inputChange]="validateDeviceName" [value]="displayName"
                [errorMessage]="nameInvalidError"></sync-text-field>
            </div>
            <!-- Rename End -->

            <!-- Permission start -->
            <div class="nameContainer permission-dialog" *ngSwitchCase="'permission'">
              <sync-text-field [inputType]="'text'" [inputChange]="validateDeviceName" [disabled]="false"
                [label]="'Device'" [placeholder]="'Input'" [value]="displayName" [leadAdornments]="true"
                [leadAdornmentsType]="'icon'" [leadIconAdornment]="
              dialog['device_name'] ||
              dialog['is_mobile']
                ? 'mobile-phone'
                : 'computer'
            " [leadTextAdornment]="''" [trailAdornments]="false" [trailTextAdornment]="''" [trailIconAdornment]="''"
                [readOnly]="true" [caption]="false" [charCounter]="false" [captionHint]="'Caption'"
                [dynamicMaxlength]="320" [minValue]="1" [maxValue]="100"></sync-text-field>
              <sync-section-header [header]="'Enable password changes'" [description]="
              'Allow this device to change your accounts password '
            " [level]="'body-1'" [showActions]="true" [showSwitch]="true" [switchConfig]="{
              size: 'default',
              disabled: false,
              label: '',
              labelPosition: 'after',
              required: true,
              ariaDescribedby: '',
              ariaLabel: '',
              ariaLabelledby: '',
              name: '',
              onChange: onDevicePermissionChange,
              checked: changeDevicePermissions,
            }" [checked]="changeDevicePermissions">
              </sync-section-header>
            </div>
            <!-- Permission end -->

            <!-- Delete start -->
            <div class="nameContainer remove-device" *ngSwitchCase="'delete'">
              <sync-text-field [label]="'Device'" [placeholder]="'Device name'" [inputType]='"text"'
                [inputChange]="validateDeviceName" [value]="displayName" [readOnly]="true" [leadAdornments]="true"
                [leadAdornmentsType]="'icon'" [leadIconAdornment]="
              dialog['device_name'] ||
              dialog['is_mobile']
                ? 'mobile-phone'
                : 'computer'
            "></sync-text-field>
              <div class="remove-text">
                <div class="subtitle remove-question">Are you sure you want to remove this device?</div>
                <div class="body-1">This will sign your account out of the device and remove it from the devices
                  list.</div>
              </div>
            </div>
            <!-- Delete end -->

            <!-- Sign-out start -->
            <div class="nameContainer log-out-dialog" *ngSwitchCase="'sign-out'">
              <sync-text-field [label]="'Web'" [inputType]='"text"' [value]="displayName" [readOnly]="true"
                [leadAdornments]="true" [leadAdornmentsType]="'icon'" [leadIconAdornment]="'web-application'"
                [trailAdornments]="false" [trailTextAdornment]="''" [trailIconAdornment]="''" [caption]="false"
                [charCounter]="false" [captionHint]="'Caption'" [dynamicMaxlength]="320" [minValue]="1"
                [maxValue]="100"></sync-text-field>
              <div class="remove-text">
                <div class="subtitle remove-question">Are you sure you want to sign out of this web session?</div>
                <div class="body-1">This session will no longer appear on the devices list.</div>
              </div>
            </div>
            <!-- Sign-out end-->

             <!-- Restore start -->
             <div class="nameContainer restore-device" *ngSwitchCase="'restore'">
              <sync-text-field [label]="'Device'" [placeholder]="'Device name'" [inputType]='"text"'
                [inputChange]="validateDeviceName" [value]="displayName" [readOnly]="true" [leadAdornments]="true"
                [leadAdornmentsType]="'icon'" [leadIconAdornment]="
              dialog['device_name'] ||
              dialog['is_mobile']
                ? 'mobile-phone'
                : 'computer'
            "></sync-text-field>
              <div class="remove-text">
                <div class="subtitle remove-question">Are you sure you want to restore this device?</div>
                <div class="body-1 remove-question">Sync will become accessible on this device again.</div>
              </div>
            </div>
            <!-- Restore end -->


          </ng-container>
        </sync-dialog>
      </div>